<form [formGroup]="form">
    <div class="name-field">
        <mat-form-field class="mat-form-style" appearance="outline">
            <mat-label>{{'GENERAL.NAME' | translate}}</mat-label>
            <input matInput class="input-field" type="text" required
                   [formControl]="nameControl"
                   (keyup)="nameChangeClick()">
            <mat-error
                    *ngIf="this.nameControl.errors?.nameValid">{{'DIALOGS.CREATE_USER.USERNAME_NOT_VALID' | translate}}</mat-error>
            <mat-error
                    *ngIf="this.nameControl.errors?.missingBoth">{{'DIALOGS.CREATE_USER.USERNAME_IS_REQUIRED' | translate}}</mat-error>
        </mat-form-field>
    </div>

    <div class="email-field">
        <mat-form-field class="mat-form-style" appearance="outline">
            <mat-label>{{'GENERAL.EMAIL.LABEL' | translate}}</mat-label>
            <input matInput class="input-field" type="text" required
                   [formControl]="emailControl"
                   (focus)="resetEmailExistValidationEvent.emit()"
                   (keyup)="emailChangeClick()">
            <mat-error
                    *ngIf="this.emailControl.errors?.emailExists">{{'DIALOGS.CREATE_USER.EMAIL_EXISTS' | translate}}</mat-error>
            <mat-error
                    *ngIf="this.emailControl.errors?.emailValid || this.emailControl.errors?.email">{{'DIALOGS.CREATE_USER.EMAIL_NOT_VALID' | translate}}</mat-error>
            <mat-error
                    *ngIf="this.emailControl.errors?.missingBoth">{{'DIALOGS.CREATE_USER.EMAIL_IS_REQUIRED' | translate}}</mat-error>
        </mat-form-field>
    </div>

    <div class="roles-wrapper">
        <app-checkbox
                [label]="patientLabel"
                [disableRipple]="true"
                [checked]="patientRoleSelected"
                [disabled]="otherRoleSelected"
                (changeEvent)="roleChange(patientRole)">
        </app-checkbox>
        <app-checkbox
                [label]="doctorLabel"
                [disableRipple]="true"
                [disabled]="patientRoleSelected"
                (changeEvent)="roleChange(doctorRole)">
        </app-checkbox>
        <app-checkbox
                [label]="editorLabel"
                [disableRipple]="true"
                [disabled]="patientRoleSelected"
                (changeEvent)="roleChange(editorRole)">
        </app-checkbox>
        <app-checkbox
                [label]="adminLabel"
                [disableRipple]="true"
                [disabled]="patientRoleSelected"
                (changeEvent)="roleChange(adminRole)">
        </app-checkbox>
    </div>
    <div class="toggle-wrapper">
        <app-slide-toggle ngDefaultControl
                          [formControl]="basicModeControl"
                          [ariaLabel]="'GENERAL.BASIC_MODE' | translate"
                          [labelText]="'GENERAL.BASIC_MODE' | translate"
                          [labelPosition]="'after'"
                          [checked]="patientRoleSelected"
                          [disabled]="!patientRoleSelected"
                          [settingName]="basicModeEnum"
                          (slideToggleEvent)="change($event)">
        </app-slide-toggle>
    </div>
</form>
